/** Brand-anchored page header band — navy with sunflower accents.
 * Drop at the top of any page (after <Header />). */
export default function PageHeaderBand({ icon: Icon, title, subtitle, actions, testId }) {
  return (
    <section
      data-testid={testId || "page-header-band"}
      className="bg-[#15233B] text-white relative overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06] bg-[radial-gradient(circle_at_15%_30%,#FFCB05_0,transparent_45%),radial-gradient(circle_at_85%_70%,#1E73C9_0,transparent_50%)]"
      />
      <div className="px-4 sm:px-6 lg:px-8 py-5 flex items-center gap-4 relative">
        {Icon && (
          <div className="h-10 w-10 rounded-lg bg-[#FFCB05] grid place-items-center shrink-0 shadow-sm">
            <Icon className="h-5 w-5 text-[#15233B]" />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <h1 className="text-2xl font-extrabold tracking-tight leading-tight">{title}</h1>
          {subtitle && (
            <div className="text-xs text-white/70 mt-0.5 tracking-tight">{subtitle}</div>
          )}
        </div>
        {actions && <div className="shrink-0 flex items-center gap-2">{actions}</div>}
      </div>
      <div className="h-[2px] bg-gradient-to-r from-transparent via-[#FFCB05] to-transparent" aria-hidden />
    </section>
  );
}
